import { MenuItem } from '@revolut-internal/ui-kit'
import { NavLink } from 'react-router-dom'

import { AppRoute, getAssistantPlaygroundRoute, getChatDebugRoute } from 'lib/router'

export const nlpPlaygroundMenuItems: MenuItem[] = [
  {
    icon: 'Chat',
    title: 'Chat debug',
    id: AppRoute.ChatDebug,
    to: getChatDebugRoute(),
    use: NavLink,
  },
  {
    icon: 'Entertainment',
    title: 'Assistant playground',
    id: AppRoute.AssistantPlayground,
    to: getAssistantPlaygroundRoute(),
    use: NavLink,
  },
]
